import { render, staticRenderFns } from "./AddEditSecurityMethod.vue?vue&type=template&id=ac2f2f04"
import script from "./AddEditSecurityMethod.vue?vue&type=script&lang=js"
export * from "./AddEditSecurityMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports